/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon20Solid = forwardRef('ArrowRoundSyncForwardIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.79 3.87A6.249 6.249 0 0 1 14.8 6H13a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1V3a1 1 0 1 0-2 0v1.34A8.248 8.248 0 0 0 1.825 8.9a1 1 0 0 0 1.983.266A6.249 6.249 0 0 1 8.79 3.87Z" }),
        React.createElement("path", { d: "M7.4 15.682a6.248 6.248 0 0 0 8.783-4.776 1 1 0 1 1 1.979.29A8.25 8.25 0 0 1 4 15.66V17a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5.2a6.248 6.248 0 0 0 2.2 1.682Z" })));
});
